import React, { use, useState } from 'react';

import { buttonProps } from 'src/components/layout/redesign/career-header-desktop/career-header-helper';
import HeaderMobile from 'src/components/layout/redesign/header-mobile';
import { useDocumentDesktopOnlyScroll } from 'src/components/layout/redesign/header-shared/use-document-desktop-only-scroll';
import { CareerCmsContent } from 'src/content/career-content';
import { SiteContext } from 'src/context/site-context';

const CareerHeaderMobile = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const setDocumentDesktopOnlyScroll = useDocumentDesktopOnlyScroll();
  const { buildType, language } = use(SiteContext);

  const { careerHeaderContent } = use(CareerCmsContent);

  const handleMenuOpen = (isOpen: boolean) => {
    setIsMobileMenuOpen(isOpen);
    setDocumentDesktopOnlyScroll(isOpen);
  };

  return (
    <HeaderMobile
      headerContent={careerHeaderContent.careerHeader}
      primaryButton={buttonProps(
        careerHeaderContent?.careerHeader.headerButtonPrimary,
        buildType,
        'Primary Button - Navigation',
        'Career Mobile Header',
        language,
        handleMenuOpen
      )}
      secondaryButton={buttonProps(
        careerHeaderContent?.careerHeader.headerButtonSecondary,
        buildType,
        '"Secondary Button" - Navigation',
        'Career Mobile Header',
        language,
        handleMenuOpen
      )}
      isMenuOpen={isMobileMenuOpen}
      setMenuOpen={handleMenuOpen}
    />
  );
};

export default CareerHeaderMobile;
